//React
import React from 'react'

const Nav = () => (
  <nav class="navbar navbar-expand-lg navbar-light bg-light"></nav>
)

export default Nav
